import { useCallback, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import createTranslator from "../../../util/translationHelper";
import { useAppStateProvider } from "../../../contextProviders/AppStateProvider";
import messages from "./translations/messages";
import helper from "./dropdownHelper";

function useDropdown({ isCancellationPending }) {
  const BLOCK = useRef("manage-plan-dropdown");
  const translate = useMemo(() => createTranslator(messages), []);
  const { updateAppStateLocal } = useAppStateProvider();
  const history = useHistory();
  const lang = window?.localStorage?.getItem("lang") ?? "en";

  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onChangeSubscription = useCallback(() => {
    close();
    helper.handleChangeSubscription(updateAppStateLocal, history, lang);
  }, [close, updateAppStateLocal, history, lang]);

  const onCancelSubscription = useCallback(() => {
    close();
    helper.handleCancelSubscription(updateAppStateLocal);
  }, [close, updateAppStateLocal]);

  const onReactivate = useCallback(() => {
    close();
    helper.handleReactivate(updateAppStateLocal);
  }, [close, updateAppStateLocal]);

  return {
    BLOCK,
    isOpen,
    isCancellationPending,
    toggle,
    close,
    onChangeSubscription,
    onCancelSubscription,
    onReactivate,
    translate,
  };
}

const Hook = {
  useDropdown,
};

export default Hook;
